"use client";

import React from "react";
import Link from "next/link";

export const FirstChallengeButton = () => {
  return (
    <Link href="/challenges">
      <button className="bg-[#CCFF00] hover:opacity-85 text-black h-11 px-8 rounded-full font-medium text-base transition-opacity cursor-pointer">
        Get started
      </button>
    </Link>
  );
};
